<template>
  <div class="imagecarousel-widget">
    <b-carousel :interval="0" controls img-width="1024" img-height="512" :no-animation="true">
     <b-carousel-slide v-for="image in options.urls" :key="image" :img-src="image">
     </b-carousel-slide>
   </b-carousel>
  </div>
</template>

<script>

export default {
  name: 'ImageCarousel',
  props: ["options"]
}
</script>
